snt-accordion {
    display: block;
    width: 100%;
    min-height: 3.5rem; // 56px, height with one line of content to reduce layout shift
    @media (min-width: map-get($grid-breakpoints, xl)) {
        min-height: 3.8125rem; // 61px, height with one line of content to reduce layout shift
    }
    .card {
        border: none;
        background-color: transparent;
    }
    margin-bottom: 5px;
    .card-header {
        position: relative;
        overflow: hidden;
        z-index: 0;
        // theme
        border: 0.25px solid $color-grey-10;
        background-color: transparent;
        padding: 0;
        border-radius: 0;
        &:first-child {
            border-radius: 0;
        }
        button {
            position: relative;
            width: 100%;
            z-index: 0;
            text-align: left;
            white-space: normal;
            // theme
            background-color: transparent;
            border: none;
            padding: 17px 75px 16px 30px;
        }
        .accordion-button-text {
            font-size: 12px;
            line-height: 1.5;
        }
    }
    
    .card-panel {
        overflow: hidden;
        transition: height 0.75s;
        &.transitioning {
            display: block;
        }
    }
    &[expanded] {
        .card-header {
            button {
                // chevron icon
                &:after {
                    background-image: url($svg-down-chevron-white);
                    transform: translate(+50%, -50%) rotate(-180deg);
                }
            }
        }
    }
    &.faq-accordion {
        .card-header {
            background-color: $color-white;
            // line across
            &:before {
                @include backdropLayout();
                height: 0;
                width: calc(100% + 4px);
                transition: $transition-duration height;
            }
        }
        .card-panel {
            // theme
            border-left: 0.25px solid $color-grey-10;
            border-right: 0.25px solid $color-grey-10;
            border-bottom: 0.25px solid $color-grey-10;
        }
        .card-body {
            padding: 20px 15px 20px 15px;
            @media (min-width: map-get($grid-breakpoints, md)) {
                padding: 20px 45px 20px 15px;
            }
            @media (min-width: map-get($grid-breakpoints, lg)) {
                padding: 30px;
            }
        }
        button {
            // chevron icon
            &:after {
                position: absolute;
                top: 50%;
                right: 1.5rem;
                background-position: center;
                transform: translate(+50%, -50%) rotate(0deg);
                content: " ";
                transition: $transition-duration transform;
                @media (min-width: map-get($grid-breakpoints, md)) {
                    right: 32px;
                }
                // theme
                width: 15px;
                height: 15px;
                background-image: url($svg-down-chevron-purple);
            }
            // animated backdrop
            &:before {
                @include backdropLayout();
                width: 0;
                height: 2px;
                transition: $transition-duration width;
            }
            &:hover,
            &:focus {
                box-shadow: none;
                outline: 0;
                // animated backdrop
                &:before {
                    width: calc(100% + 4px);
                }
            }
        }
        &[expanded] {
            .card-header {
                button {
                    color: $color-white;
                    // animated line
                    &:before {
                        width: 100%;
                    }
                }
                // animated backdrop
                &:before {
                    height: 100%;
                }
            }
        }
    }
    &.transcript-accordion {
        .card-header {
            width: fit-content;
            border: none;
            .h1,
            .h2,
            .h3,
            .h4,
            .h5,
            .h6 {
                font-size: 14px;
                line-height: 23px;
            }
            button {
                padding: 0 1rem 0 1.5625rem;
                border: 1px solid;
                border-color: transparent;
                &:after {
                    right: 1rem;
                }
                &:hover,
                &:focus {
                    color: $color-primary-accent;
                    outline: none;
                    box-shadow: none;
                    [slot="summary"] {
                        &:before {
                            @media (min-width: map-get($grid-breakpoints, md)) {
                                visibility: visible;
                                -webkit-transform: scaleX(1);
                                transform: scaleX(1);
                            }
                        }
                    }
                }
                &:focus,
                &:focus-visible {
                    border-color: #147582;
                    box-shadow: none;
                }
            }
            button .expand-icon {
                padding-left: 1px;
            }
        }

        [slot="summary"] {
            font-family: "Averta-Regular", Arial, Helvetica, sans-serif;
            font-size: 0.875rem;
            line-height: 1.625rem;
            position: relative;
            display: inline-block;
            &:before {
                content: "";
                position: absolute;
                width: 100%;
                height: 1px;
                bottom: 4px;
                left: 0;
                background-color: $color-links;
                visibility: hidden;
                -webkit-transform: scaleX(0);
                transform: scaleX(0);
                transform-origin: left;
                -webkit-transition: all 0.25s ease-in-out 0s;
                transition: all 0.25s ease-in-out 0s;
                background: $color-primary-accent;
            }
        }
        .card-panel {
            margin-top: 20px;
            border: 1px solid #e5e5e5;
            background-color: #ffffff;
            box-shadow: 0.2px 0.2px 10px $color-grey-06;
            border-radius: 0;
             ::-webkit-scrollbar {
                width: 10px;
            }
             ::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(245, 245, 245, 1);
                -webkit-border-radius: 10px;
                border-radius: 10px;
                background-color: #f5f5f5;
            }
             ::-webkit-scrollbar-thumb {
                -webkit-border-radius: 10px;
                border-radius: 10px;
                background: $color-primary-accent;
                -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
            }
             ::-webkit-scrollbar-thumb:window-inactive {
                background: $color-primary-accent;
            }
        }
        .card-body {
            padding: 1.5625rem 0.9375rem;
            @media (min-width: map-get($grid-breakpoints, md)) {
                padding: 1.5625rem;
            }
            [slot="details"] {
                overflow-y: auto;
                scrollbar-width: thin;
                scrollbar-color: #7f7f7f transparent;
                max-height: 250px;
                padding: 0 1.5625rem 0 0;
                @media (min-width: map-get($grid-breakpoints, md)) {
                    padding: 0 3.1255rem 0 0;
                }
                @media (min-width: map-get($grid-breakpoints, lg)) {
                    max-height: 350px;
                }
                p {
                    font-size: 0.875rem;
                    line-height: 1.45rem;
                }
            }
        }
        .expand-icon {
            height: 0.9375rem;
            width: 0.9375rem;
            font-size: 0.9375rem;
            line-height: 0.9375rem;
            position: absolute;
            left: 0;
            top: 6px;
            margin: auto;
            @media (min-width: map-get($grid-breakpoints, md)) {
                top: 0;
                bottom: 0;
            }
        }
    }
    &.legal-footer-accordion {
        .card-header {
            margin-bottom: 0.475em;
            button .expand-icon {
                padding: 3px;
                margin: 0;
                position: relative;
            }
            button {
                border: 1px solid;
                border-color: transparent;
                width: auto;
                padding-right: 3px;
                padding-left: 0;
                &:focus,
                &:focus-visible {
                    border-color: #147582;
                    box-shadow: none;
                }
                &:hover {
                    span {
                        color: #147582;
                    }
                }
            }
        }
        .expand-icon {
            position: relative;
            top: 0;
            left: 0;
        }
        .accordion-button-text {
            text-decoration: underline transparent;
            margin-left: 5px;
        }
        .accordion-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover {
                .accordion-button-text {
                    text-decoration: underline #147582;
                    ;
                }
            }
        }
        .card-panel {
            margin-top: 0;
            border: none;
            box-shadow: none;
        }
        .card {
            padding-top: 15px;
        }
        .card-body {
            padding: 0;
        }
        .card-body [slot="details"] {
            padding: 0;
            max-height: none;
        }
        .card-body [slot="details"]::-webkit-scrollbar {
            width: 0px;
            background: transparent;
        }
        .card-body [slot="details"] .footer-legal p {
            font-size: 12px;
            line-height: 1.5;
        }
    }
}

snt-accordion-group {
    width: 100%;
    .spacings {
        snt-accordion.faq-accordion button {
            @media (max-width: map-get($grid-breakpoints, md)) {
                padding: 15px 45px 15px 15px;
            }
        }
    }
}

.two-column-combined {
    & snt-accordion-group {
        flex-grow: 1;
    }
}